import { apiV2AuthHeaders } from "@/api/v2Headers";
import { API_V2_ROOT } from "@/config";

import type { CreateDocsAccessCodeInput, DocsAccessCode } from "./types";

const BASE = `${API_V2_ROOT}/v2/internal/docs/access-codes`;

async function request<T>(path: string, init?: RequestInit): Promise<T> {
  const response = await fetch(`${BASE}${path}`, {
    ...init,
    headers: {
      ...(await apiV2AuthHeaders()),
      "Content-Type": "application/json",
      ...(init?.headers ?? {}),
    },
  });

  if (!response.ok) {
    let message = `Request failed (${response.status})`;
    try {
      const body = await response.json();
      message = body?.error || body?.status || message;
    } catch {
      // Non-JSON error body; fall back to the generic message.
    }
    throw new Error(message);
  }

  if (response.status === 204) {
    return undefined as T;
  }
  return response.json() as Promise<T>;
}

export async function listDocsAccessCodes(): Promise<DocsAccessCode[]> {
  const res = await request<{ data: DocsAccessCode[] }>("/");
  return res.data;
}

export function createDocsAccessCode(
  input: CreateDocsAccessCodeInput,
): Promise<DocsAccessCode> {
  return request<DocsAccessCode>("/", {
    method: "POST",
    body: JSON.stringify(input),
  });
}

export function revokeDocsAccessCode(id: string): Promise<void> {
  return request<void>(`/${id}/revoke`, { method: "POST" });
}
